import React from 'react';
import { Paragraph } from '../../paragraph';
import { connect } from 'react-redux';
const width = window.innerWidth;

const TapText = props => {
    const { fontSize } = props;

    let text = '';
    const oneWordText = fontSize !== 'medium' || width < 600;

    if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent,
        )
    ) {
        if (oneWordText) {
            text = 'Tap';
        } else {
            text = 'Tap here repeatedly';
        }
    } else {
        if (oneWordText) {
            text = 'Click';
        } else {
            text = 'Click here repeatedly';
        }
    }

    return (
        <Paragraph withSpacing={false} textAlign="center">
            {text}
        </Paragraph>
    );
};

const mapStateToProps = state => {
    return {
        fontSize: state.settings.accessibility.fontSize,
    };
};

const connected = connect(mapStateToProps)(TapText);
export { connected as TapText };
